import React, { useState, useEffect, useCallback, useRef } from 'react';

import imgNervurluDemir from '../projectitems/ürünler/Cesannervurludemir.webp';
import imgMantolama from '../projectitems/ürünler/bonuspro-mantolama.jpg';
import imgHararCuvali from '../projectitems/ürünler/hararcuvali.jpg';
import imgKum from '../projectitems/ürünler/kum.jpg';
import imgMicir from '../projectitems/ürünler/mıcır.png';
import imgNaylonBranda from '../projectitems/ürünler/naylonbranda.jpeg';
import imgOlukluKarton from '../projectitems/ürünler/oluklukarton.jpg';
import imgPatpatNaylon from '../projectitems/ürünler/patpatnaylon.webp';

const products = [
    { id: 1, image: imgNervurluDemir, title: 'Nervürlü Demir' },
    { id: 2, image: imgMantolama, title: 'XPS Isı Yalıtım Levhası' },
    { id: 3, image: imgHararCuvali, title: 'Harar Çuvalı' },
    { id: 4, image: imgKum, title: 'Kum' },
    { id: 5, image: imgMicir, title: 'Mıcır', whiteBg: true },
    { id: 6, image: imgNaylonBranda, title: 'Naylon Branda' },
    { id: 7, image: imgOlukluKarton, title: 'Oluklu Karton', imgPosition: 'top' },
    { id: 8, image: imgPatpatNaylon, title: 'Patpat Naylon' },
];

const total = products.length;

const getOffset = (index, active) => {
    let diff = index - active;
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;
    return diff;
};

const SWIPE_THRESHOLD = 50;

const OurProducts = () => {
    const [active, setActive] = useState(0);
    const touchStartX = useRef(0);

    const next = useCallback(() => {
        setActive((prev) => (prev + 1) % total);
    }, []);

    const prev = useCallback(() => {
        setActive((prev) => (prev - 1 + total) % total);
    }, []);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        const deltaX = e.changedTouches[0].clientX - touchStartX.current;
        if (deltaX < -SWIPE_THRESHOLD) next();
        else if (deltaX > SWIPE_THRESHOLD) prev();
    };

    useEffect(() => {
        const timer = setInterval(next, 3000);
        return () => clearInterval(timer);
    }, [next]);

    return (
        <section className="our-products" id="urunler">
            <div className="our-products__container">
                <div className="our-products__header">
                    <p className="section-eyebrow">Tedarik & Satış</p>
                    <h2 className="section-title">ÜRÜNLERİMİZ</h2>
                    <p className="our-products__desc">
                        Projeleriniz için ihtiyaç duyduğunuz tüm yapı malzemelerini tek noktadan temin edin.
                    </p>
                </div>

                <div className="our-products__carousel">
                    <button className="our-products__arrow our-products__arrow--prev" onClick={prev} aria-label="Önceki">
                        ‹
                    </button>

                    <div
                        className="our-products__track"
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                    >
                        {products.map((p, i) => {
                            const offset = getOffset(i, active);
                            const isVisible = Math.abs(offset) <= 2;
                            const isCenter = offset === 0;
                            const opacity = isCenter ? 1 : Math.abs(offset) === 1 ? 0.4 : 0.15;

                            return (
                                <div
                                    className="our-products__slide"
                                    key={p.id}
                                    style={{
                                        transform: `translateX(${offset * 370}px)`,
                                        opacity: isVisible ? opacity : 0,
                                        filter: isCenter ? 'none' : `blur(${Math.abs(offset)}px)`,
                                        zIndex: 10 - Math.abs(offset),
                                        pointerEvents: isVisible ? 'auto' : 'none',
                                    }}
                                    onClick={() => !isCenter && setActive(i)}
                                >
                                    <div className="our-product-card">
                                        <div className={`our-product-card__visual${p.whiteBg ? ' our-product-card__visual--white' : ''}`}>
                                            <img
                                                src={p.image}
                                                alt={p.title}
                                                className="our-product-card__img"
                                                style={p.imgPosition ? { objectPosition: p.imgPosition } : undefined}
                                            />
                                        </div>
                                        <div className="our-product-card__info">
                                            <h3 className="our-product-card__title">{p.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <button className="our-products__arrow our-products__arrow--next" onClick={next} aria-label="Sonraki">
                        ›
                    </button>
                </div>

                <div className="our-products__dots">
                    {products.map((_, i) => (
                        <button
                            key={i}
                            className={`our-products__dot${i === active ? ' our-products__dot--active' : ''}`}
                            onClick={() => setActive(i)}
                            aria-label={`Ürün ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurProducts;
